import NavBar from '@/components/Nav.vue';

export default {
    name: 'DeliverySubmitPage',
    components: {
        NavBar,
    },
    data() {
        return {
            entityKey: null,
            address: '',
            type: null
        }
    },
    created() {
        this.entityKey = this.$route.query.entity_id;
    },
    methods: {
        submit() {
            if (! this.address || ! this.entityKey) {
                this.$toast('请输入投递地址');
            } else {
                this.$http.post('deliver', {entity_id: this.entityKey, address: this.address}).then(result => {
                    this.type = result.data.success ? 'success' : 'fail';
                });
            }
        }
    }
}